"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { TerraLink } from "../../component/TerraLink/TerraLink";
import { InlineMediaPanel } from "../../component/InlineMediaPanel/InlineMediaPanel";
import { InlineMediaTabView } from "./InlineMediaTabView";
import { InlineMediaCarouselView } from "./InlineMediaCarouselView";
import { darkTextureWrapper, colorSettingDetection, renderHeaderConditionally } from "../../utils/functions";
import { CommonDescription } from "../../component/CommonDescription/CommonDescription";
import { layoutHeaderClasses, layoutHeaderBigClasses, layoutSubheaderClasses, layoutEyebrowClasses } from "@/components/tailwindHelpers";
export interface LayoutInlineMedia {
  id?: string;
  eyebrow?: string;
  header?: string;
  headerElement?: "h1" | "h2";
  subheader?: string;
  description?: string;
  buttons?: TerraLink[];
  inlineMediaPanels?: InlineMediaPanel[];
  variant?: "tabs" | "carousel";
  presetTheme?: "t2-theme-one" | "t2-theme-two" | "t2-theme-three" | "t2-theme-four" | "t2-theme-five" | "t2-theme-six" | "t2-theme-seven";
  isHeaderBig?: boolean;
  isWrapped?: boolean;
  componentImagePriority?: "high" | "auto" | "low";
  isLCP?: boolean;
}
export const LayoutInlineMedia = t0 => {
  const $ = _c(41);
  const {
    id,
    eyebrow,
    header,
    headerElement: t1,
    subheader,
    description,
    buttons,
    inlineMediaPanels,
    variant,
    presetTheme,
    isHeaderBig,
    isWrapped,
    componentImagePriority,
    isLCP: t2
  } = t0;
  const headerElement = t1 === undefined ? "h2" : t1;
  const isLCP = t2 === undefined ? false : t2;
  const t3 = presetTheme || "";
  let t4;
  if ($[0] !== t3) {
    t4 = colorSettingDetection(t3);
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const colorSetting = t4;
  const t5 = presetTheme || "";
  let t6;
  if ($[2] !== t5) {
    t6 = darkTextureWrapper(t5);
    $[2] = t5;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const componentStyles = t6;
  const displayMode = variant || "carousel";
  const headerClasses = `mb-10 ${isHeaderBig ? layoutHeaderBigClasses : layoutHeaderClasses}`;
  const t7 = header || "";
  let t8;
  if ($[4] !== headerClasses || $[5] !== headerElement || $[6] !== t7) {
    t8 = renderHeaderConditionally(headerClasses, t7, headerElement);
    $[4] = headerClasses;
    $[5] = headerElement;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const finalHeader = t8;
  const wrapperClasses = isWrapped ? "w-full sm:px-5 lg:px-20 mx-auto max-w-[1440px]" : "";
  let t9;
  if ($[8] !== componentImagePriority || $[9] !== displayMode || $[10] !== id || $[11] !== inlineMediaPanels || $[12] !== isLCP) {
    t9 = () => {
      if (!inlineMediaPanels || inlineMediaPanels.length === 0) {
        return null;
      }
      if (inlineMediaPanels.length === 1) {
        return <div className="t2-layout-inline-media__list-carousel-panel-wrap w-full"><InlineMediaPanel {...inlineMediaPanels[0]} componentImagePriority={componentImagePriority} isLCP={isLCP} /></div>;
      }
      if (displayMode === "tabs") {
        return <InlineMediaTabView id={id} panels={inlineMediaPanels} componentImagePriority={componentImagePriority} isLCP={isLCP} />;
      }
      return <InlineMediaCarouselView panels={inlineMediaPanels} componentImagePriority={componentImagePriority} isLCP={isLCP} />;
    };
    $[8] = componentImagePriority;
    $[9] = displayMode;
    $[10] = id;
    $[11] = inlineMediaPanels;
    $[12] = isLCP;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const renderPanels = t9;
  const t10 = `py-[100px] ${presetTheme || ""} ${colorSetting}`;
  let t11;
  if ($[14] !== eyebrow) {
    t11 = eyebrow && <div className={layoutEyebrowClasses}>{eyebrow}</div>;
    $[14] = eyebrow;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== subheader) {
    t12 = subheader && <div className={layoutSubheaderClasses}>{subheader}</div>;
    $[16] = subheader;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== description) {
    t13 = description && <CommonDescription description={description} className="t2-layout__description w-full" />;
    $[18] = description;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== finalHeader || $[21] !== t11 || $[22] !== t12 || $[23] !== t13) {
    t14 = <div className="flex flex-wrap px-5 sm:px-0 pb-10"><div className="basis-full max-w-full px-0 lg:basis-2/3 lg:max-w-[66.666%]">{t11}{finalHeader}{t12}{t13}</div></div>;
    $[20] = finalHeader;
    $[21] = t11;
    $[22] = t12;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== renderPanels) {
    t15 = renderPanels();
    $[25] = renderPanels;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t15) {
    t16 = <div className="w-full">{t15}</div>;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== buttons) {
    t17 = buttons && buttons.length > 0 && <div className="mt-5 sm:mt-[30px] lg:mt-[60px] flex flex-col sm:flex-row justify-center items-center gap-[30px] px-5 sm:px-0 [&_.t2-button]:w-full sm:[&_.t2-button]:w-auto">{buttons.map(_temp)}</div>;
    $[29] = buttons;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== t14 || $[32] !== t16 || $[33] !== t17 || $[34] !== wrapperClasses) {
    t18 = <div className={wrapperClasses}>{t14}{t16}{t17}</div>;
    $[31] = t14;
    $[32] = t16;
    $[33] = t17;
    $[34] = wrapperClasses;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== componentStyles || $[37] !== id || $[38] !== t10 || $[39] !== t18) {
    t19 = <div key={id} className={t10} style={componentStyles} data-testid="layout-inline-media">{t18}</div>;
    $[36] = componentStyles;
    $[37] = id;
    $[38] = t10;
    $[39] = t18;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  return t19;
};
function _temp(btn, index) {
  return <TerraLink tabIndex={0} key={`btn-${btn.id}-${index}`} {...btn} />;
}